// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5b4c8d8c","885":"bcfa9cc3","977":"33efc154"}[chunkId] + ".chunk.js";
};